/* eslint-disable import/no-unresolved */
import $ from "cash-dom";
import Cookies from "js-cookie";
import { isCrawler } from "@usafacts/frontend-library-utils/userAgent";
var COOKIE_TRUE = "1";
var COOKIE_DAYS = 90;
export default function () {
  var newsletterHidden = isCrawler() ? COOKIE_TRUE : Cookies.get("newsletterHidden");

  function removeNewsletter() {
    $("#newsletter__sticky").remove();
  }

  if (newsletterHidden === COOKIE_TRUE) {
    removeNewsletter();
  } else {
    $("#newsletter__sticky").removeClass("hidden");
    $(".js-newsletter--close").on("click", function (e) {
      e.preventDefault();
      removeNewsletter();
      Cookies.set("newsletterHidden", COOKIE_TRUE, {
        expires: COOKIE_DAYS
      });
    });
  }
}